module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1600@2x-62f033e985da2c581cf51d4261f669c0.jpg";